import { AppRoute } from "app";
import { DigitalJourneyRoute } from "app/DigitalJourneyAppFlow/constants";

export const replaceSessionInAppRoute = (appRoute: AppRoute | DigitalJourneyRoute, session: string): AppRoute | DigitalJourneyRoute =>
  appRoute.replace(":session", session) as AppRoute | DigitalJourneyRoute;
